<template>
    <main-layout>
        <div class="loader">
            <div class="spinner"></div>
            <p>Connexion en cours...</p>
            <p>Merci de patienter</p>
        </div>
    </main-layout>
</template>

<script>



import Config from "@/js/config";

export default {
    data(){
        return {

        }
    },

    mounted() {
        let token = this.$route.query.code;
        if (token) {

            //fetch curl
            fetch(
                Config.urlAPI + "/sso/connexion/front",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: `code=${token}`,
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    if(data.access_token !== undefined){
                        localforage.setItem('api-token', data.access_token);
                        localforage.setItem('lastConnexion', new Date().getTime()).then(() => {
                            window.location.href = "/#/init";
                        });
                    }else{
                        window.location.href = "/#/login";
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }else{
            window.location.href = "/#/home";
        }
    }
}
</script>

<style scoped>
    .loader {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50vh;
        flex-direction: column;
    }

    .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-left-color: #7983ff;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
</style>




// WEBPACK FOOTER //
// Sso.vue?131ef440